module.exports = __webpack_public_path__ + "static/media/appstore-1c.6948a241.png";